import { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { getIsDarkMode } from "@/store/slices/webConfig";
import { lightTheme, darkTheme } from "../constants/themes/muiTheme";

interface MuiThemeOverideProviderProps {
  children: React.ReactNode;
}

export function MuiThemeOverideProvider({ children }: MuiThemeOverideProviderProps) {
  const isDarkMode = useSelector(getIsDarkMode);
  const [theme, setTheme] = useState(isDarkMode ? darkTheme : lightTheme);

  useEffect(() => {
    const newTheme = isDarkMode ? darkTheme : lightTheme;
    document.body.className = isDarkMode ? "dark" : "light";
    setTheme(newTheme);
  }, [isDarkMode]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
